<template>
  <div id="app" style="width:100%;height:100%;">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue